export const projects = [
  {
    title: "GitHub",
    description: "Repos and recent work.",
    href: "https://github.com/Felipevillajr",
    tags: ["Code", "Open source"],
  },
  {
    title: "BrainStation Final Project",
    description: "Forum-style app using Node and MySQL.",
    href: "https://pacific-retreat-51764.herokuapp.com/",
    tags: ["Node.js", "MySQL", "Full stack"],
  },
  {
    title: "Free Password Generator",
    description:
      "Generate secure passwords quickly with adjustable options in a clean, fast interface.",
    href: "https://github.com/Felipevillajr/passwordgen001",
    liveHref: "https://passwordgenfree.netlify.app",
    liveLabel: "Live Demo",
    tags: ["Node.js", "Vite", "Capacitor"],
  },
  {
    title: "Terminal News Reader",
    description:
      "A terminal-first news scraper and reader with source management, article search, and interactive browsing.",
    href: "https://github.com/Felipevillajr/newscrapperapp",
    tags: ["Python", "Typer", "Rich", "Textual"],
  },
];

